import { PixelPlaceholderLoader } from "@similarweb/ui-components";

import { Block } from "app/components/PackageSwitcher/components/PackageFeatureInfo/PackageFeatureInfo.styled";

export const PackageFeatureInfoSkeleton = () => {
    return (
        <Block>
            <PixelPlaceholderLoader
                width={131}
                height={16}
            />
            <PixelPlaceholderLoader
                width={202}
                height={24}
            />
            <PixelPlaceholderLoader
                width={165}
                height={40}
            />
            <PixelPlaceholderLoader
                width={244}
                height={20}
            />
        </Block>
    );
};
